module.exports = __webpack_public_path__ + "img/noshareme.26bfd9ea.svg";